import React, { useState } from 'react';
import './TheTeacherDashboard.css';
import Announcement from './imageFiles/Speaker.png';
import Ann_icon from './imageFiles/Ann_icon.png';

export default function TeacherAnnouncements({
  allRecentAnnouncements,
  weeklyAnnouncements,
  monthlyAnnouncements,
  initial_loading,
}) {
  const [activeTab, setActiveTab] = useState('All');
  const [selectedAnnouncement, setSelectedAnnouncement] = useState(null);

  const tabData = {
    All: allRecentAnnouncements,
    'Last month': monthlyAnnouncements,
    '7 Days': weeklyAnnouncements,
  };

  const skeletonList = Array(4).fill({});

  const renderAnnouncements = (data) => {
    return data?.map((item, index) => (
      <div
        className="announcement-row"
        key={index}
        onClick={() => setSelectedAnnouncement(item)}
      >
        <div className="announcement-icon">
          <img
            src={Announcement}
            alt="announcement"
            className="me-3 mt-1"
          />
        </div>
        <div className="announcement-text">
          <p className="stdannouncement-title">
            {item.announcement_title || 'Announcement Title'}
          </p>
          <p className="announcement-body">
            {item.announcement_body?.length > 70
              ? `${item.announcement_body.substring(0, 70)}...`
              : item.announcement_body || 'There are many variations of passages of Lorem Ipsum available'}
          </p>
        </div>
      </div>
    ));
  };

  return (
    <div className="teacher-announcements">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h6 className="ann-title">Announcements</h6>
        <span className="dots-icon">⋯</span>
      </div>

      <div className="tabs-section d-flex align-items-center mb-3">
        <div>&emsp;</div>
        <div className="tabs">
          {['All', 'Last month', '7 Days'].map((tab) => (
            <button
              key={tab}
              className={`tab-button ${activeTab === tab ? 'active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>
        <div>&emsp;</div>
      </div>

      <div className="announcement-list">
        {initial_loading ? (
          skeletonList.map((_, index) => (
            <div className="announcement-row" key={index}>
              <div className="announcement-icon skeleton-icon-placeholder" />
              <div className="announcement-text">
                <div className="skeleton skeleton-title mb-2" />
                <div className="skeleton skeleton-body" />
              </div>
            </div>
          ))
        ) : (
          renderAnnouncements(tabData[activeTab])
        )}
      </div>

      {selectedAnnouncement && (
        <div className="announcement-modal" onClick={() => setSelectedAnnouncement(null)}>
          <div className="announcement-popup" onClick={(e) => e.stopPropagation()}>
            <div className="announcement-modal-icon-wrapper">
              <div className="announcement-modal-icon">
                <img src={Ann_icon} alt="Announcement Icon" />
              </div>
            </div>
            <h2 className="announcement-title">{selectedAnnouncement.announcement_title}</h2>
            <div className="announcement-body">
              {selectedAnnouncement.announcement_body}
            </div>
            <div className="announcement-actions">
              <button
                className="announcement-btn cancel-btn"
                onClick={() => setSelectedAnnouncement(null)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}